export default {
    SERVER_URL: '',
}



// WEBPACK FOOTER //
// ./src/config.ts